import FaixaAit from "./FaixaAit";
import StatusAutoInfracaoTransito from "./StatusAutoInfracaoTransito";
import OrgaoAutuacao from "./OrgaoAutuacao";
import FormaAutuacao from "./FormaAutuacao";
import Agente from "./Agente";
import VigenciaCodigoInfracao from "./VigenciaCodigoInfracao";
import UnidadeMedida from "./UnidadeMedida";
import TipoAgente from "./TipoAgente";
import VeiculoAutoInfracaoTransito from "./VeiculoAutoInfracaoTransito";
import MotivoCancelamento from "./MotivoCancelamento";
import PessoaAutoInfracaoTransito from "./PessoaAutoInfracaoTransito";
import Notificacao from "./Notificacao";
import AutoInfracaoSiatuDetalhe from "./AutoInfracaoSiatuDetalhe";

class AutoInfracaoTransito {
    constructor(
        {
            id = null,
            hash = null,
            faixa_ait_id = null,
            num_ait = null,
            num_ait_composto = null,
            status_auto_infracao_transito_id = null,
            data_hora_infracao = null,
            data_infracao = null,
            hora_infracao = null,
            orgao_autuacao_id = null,
            forma_autuacao_id = null,
            agente_id = null,
            data_atribuicao = null,
            data_processamento_sram = null,
            vigencia_codigo_infracao_id = null,
            velocidade_aferida = null,
            velocidade_considerada = null,
            unidade_medida_id = null,
            numero_processamento_sram = null,
            codigo_renainf = null,
            created_at = null,
            updated_at = null,
            deleted_at = null,
            usuario_id = null,
            tipo_agente_id = null,
            veiculo_auto_infracao_transito_id,
            prazo_defesa = null,
            prazo_fici = null,
            prazo_recurso_jari = null,
            ind_problema_triagem = false,
            motivo_cancelamento_id = null,
            local_auto_infracao_transito = [],
            local_auto_infracao_transito_objeto = {},
            data_baixa_ait_sram = null,
            ind_multa_divida_ativa = false,
            ind_multa_estornada = false,
            ind_multa_prescrita = false,
            ind_multa_quitada = false,
            ind_multa_suspensa = false,
            ind_leilao = false,
            data_cobranca_obrigatoria_sram= null,
            status_guia_siatu=null,
            codigo_lancamento_siatu=null,
            data_conversao_advertencia = null,
            ind_liberado_emissao_nap = null,
            local_infracao_complemento = null,
            local_infracao_principal = null,
            local_infracao_referencia = null,
            prazo_recurso_cetran = null,


            //ORM
            faixa_ait = {},
            status_auto_infracao_transito = {},
            orgao_infracao = {},
            forma_autuacao = {},
            agente = {},
            vigencia_codigo_infracao = {},
            unidade_medida = {},
            tipo_agente = {},
            veiculo_auto_infracao_transito = {},
            motivo_cancelamento = {},
            pessoa_auto_infracao_transito = {},
            pessoas_auto_infracao_transito = [],
            orgao_autuacao = {},
            notificacao = [],
            ait_eletronico = null,
            data_cancelamento = null,
            auto_infracao_siatu_detalhe = {}
        } = {}
    ) {
        this.id = id;
        this.hash = hash;
        this.faixa_ait_id = faixa_ait_id;
        this.num_ait = num_ait;
        this.num_ait_composto = num_ait_composto;
        this.status_auto_infracao_transito_id = status_auto_infracao_transito_id;
        this.data_hora_infracao = data_hora_infracao;
        this.data_processamento_sram = data_processamento_sram;
        this.data_infracao = data_infracao;
        this.hora_infracao = hora_infracao;
        this.orgao_autuacao_id = orgao_autuacao_id;
        this.forma_autuacao_id = forma_autuacao_id;
        this.agente_id = agente_id;
        this.data_atribuicao = data_atribuicao;
        this.vigencia_codigo_infracao_id = vigencia_codigo_infracao_id;
        this.velocidade_aferida = velocidade_aferida;
        this.velocidade_considerada = velocidade_considerada;
        this.unidade_medida_id = unidade_medida_id;
        this.numero_processamento_sram = numero_processamento_sram;
        this.codigo_renainf = codigo_renainf;
        this.created_at = created_at;
        this.updated_at = updated_at;
        this.deleted_at = deleted_at;
        this.usuario_id = usuario_id;
        this.tipo_agente_id = tipo_agente_id;
        this.veiculo_auto_infracao_transito_id = veiculo_auto_infracao_transito_id;
        this.prazo_defesa = prazo_defesa;
        this.prazo_fici = prazo_fici;
        this.prazo_recurso_jari = prazo_recurso_jari;
        this.ind_problema_triagem = ind_problema_triagem;
        this.ind_multa_divida_ativa = ind_multa_divida_ativa,
        this.ind_multa_estornada = ind_multa_estornada,
        this.ind_multa_prescrita = ind_multa_prescrita,
        this.ind_multa_quitada = ind_multa_quitada,
        this.ind_multa_suspensa = ind_multa_suspensa,
        this.ind_leilao = ind_leilao;
        this.status_guia_siatu = status_guia_siatu,
        this.codigo_lancamento_siatu = codigo_lancamento_siatu,
        this.data_conversao_advertencia = data_conversao_advertencia,
        this.ind_liberado_emissao_nap = ind_liberado_emissao_nap,

        this.motivo_cancelamento_id = motivo_cancelamento_id;
        this.local_auto_infracao_transito = local_auto_infracao_transito;
        this.local_auto_infracao_transito_objeto = local_auto_infracao_transito_objeto;
        this.data_baixa_ait_sram = data_baixa_ait_sram;
        this.data_cancelamento = data_cancelamento;
        this.data_cobranca_obrigatoria_sram = data_cobranca_obrigatoria_sram;
        this.local_infracao_complemento = local_infracao_complemento;
        this.local_infracao_principal = local_infracao_principal;
        this.local_infracao_referencia = local_infracao_referencia;
        this.prazo_recurso_cetran = prazo_recurso_cetran;


        //ORM
        this.faixa_ait = faixa_ait ? new FaixaAit(faixa_ait) : new FaixaAit();
        this.status_auto_infracao_transito = status_auto_infracao_transito ? new StatusAutoInfracaoTransito(status_auto_infracao_transito) : new StatusAutoInfracaoTransito();
        this.orgao_infracao = orgao_infracao ? new OrgaoAutuacao(orgao_infracao) : new OrgaoAutuacao();
        this.forma_autuacao = forma_autuacao ? new FormaAutuacao(forma_autuacao) : new FormaAutuacao();
        this.agente = agente ? new Agente(agente) : new Agente();
        this.vigencia_codigo_infracao = vigencia_codigo_infracao ? new VigenciaCodigoInfracao(vigencia_codigo_infracao) : new VigenciaCodigoInfracao();
        this.unidade_medida = unidade_medida ? new UnidadeMedida(unidade_medida) : new UnidadeMedida();
        this.tipo_agente = tipo_agente ? new TipoAgente(tipo_agente) : new TipoAgente();
        this.veiculo_auto_infracao_transito = veiculo_auto_infracao_transito ? new VeiculoAutoInfracaoTransito(veiculo_auto_infracao_transito) : new VeiculoAutoInfracaoTransito();
        this.motivo_cancelamento = motivo_cancelamento ? new MotivoCancelamento(motivo_cancelamento) : new MotivoCancelamento();
        this.pessoa_auto_infracao_transito = pessoa_auto_infracao_transito ? new PessoaAutoInfracaoTransito(pessoa_auto_infracao_transito) : new PessoaAutoInfracaoTransito();
        this.pessoas_auto_infracao_transito = pessoas_auto_infracao_transito;
        this.orgao_autuacao = orgao_autuacao ? new OrgaoAutuacao(orgao_autuacao) : new OrgaoAutuacao();
        this.notificacao = notificacao && Array.isArray(notificacao) && notificacao.length > 0 ? notificacao.map(nt => {return new Notificacao(nt)}) : [];
        this.ait_eletronico = ait_eletronico;
        this.auto_infracao_siatu_detalhe = auto_infracao_siatu_detalhe ? new AutoInfracaoSiatuDetalhe(auto_infracao_siatu_detalhe) : new AutoInfracaoSiatuDetalhe();
    }


    isCancelado(){   return  this.status_auto_infracao_transito.isCancelado()    }

    isTalaoManual(){   return  parseInt(this.forma_autuacao.codigo) == 1    }
    isAplicativo(){   return  parseInt(this.forma_autuacao.codigo) == 6    }
    isMultaNIC(){   return  parseInt(this.forma_autuacao.codigo) == 12    }
    isEletronico(){   return !this.isTalaoManual() && !this.isAplicativo() && !this.isMultaNIC()   }


    getPenalidade()
    {
        let penalidade = this.notificacao.find(el => 
             
            el.lote_remessa_correio.id !=null 
            ? (el.lote_remessa_correio.tipo_notificacao.tipo_nit_nap != 'NIT' && el.deleted_at == null )
            : (el.notificacao_pendente && el.notificacao_pendente.tipo_notificacao.tipo_nit_nap != 'NIT' && el.notificacao_pendente.deleted_at == null)
        );
        return penalidade;
    }


    temPenalidade()
    {
        let penalidade = this.getPenalidade();
        return penalidade !== undefined && penalidade !== null;
    }

    descricaoSituacaoPenalidade(){

        var penalidade = this.notificacao.find(el => el.lote_remessa_correio.tipo_notificacao.tipo_nit_nap == 'NAE' || el.lote_remessa_correio.tipo_notificacao.tipo_nit_nap == 'NAP' || el.lote_remessa_correio.tipo_notificacao.tipo_nit_nap == 'NIC');
        if( penalidade ) return penalidade.lote_remessa_correio.tipo_notificacao.tipo_nit_nap+" emitida";

        var penalidadePendente = this.notificacao.find(el => el.notificacao_pendente.tipo_notificacao.tipo_nit_nap == 'NAE' || el.notificacao_pendente.tipo_notificacao.tipo_nit_nap == 'NAP' || el.notificacao_pendente.tipo_notificacao.tipo_nit_nap == 'NIC');
        if(!penalidadePendente) return "Não emitida";
        else return penalidadePendente.notificacao_pendente.tipo_notificacao.tipo_nit_nap+" com pendência";

    }

    cssDescricaoSituacaoPenalidade(){
        var penalidade = this.notificacao.find(el => el.lote_remessa_correio.tipo_notificacao.tipo_nit_nap == 'NAE' || el.lote_remessa_correio.tipo_notificacao.tipo_nit_nap == 'NAP' || el.lote_remessa_correio.tipo_notificacao.tipo_nit_nap == 'NIC');
        return penalidade ? "emitido" : "nemitido";
    }


}

export default AutoInfracaoTransito;